import { Controller } from "@hotwired/stimulus"
import { reducedMotion } from "~/lib/motion"

// Prev/next buttons for a scroll-snapping track; scrolls one card at a time
export default class extends Controller {
  static targets = ["track"]

  next() { this.scroll(1) }
  previous() { this.scroll(-1) }

  scroll(direction) {
    const card = this.trackTarget.firstElementChild
    const gap = parseFloat(getComputedStyle(this.trackTarget).columnGap) || 0
    this.trackTarget.scrollBy({ left: direction * (card.offsetWidth + gap), behavior: reducedMotion ? "auto" : "smooth" })
  }
}
